import { useMutation, useQueryClient } from "react-query";

import { api } from "../util/api";

interface IHabitId {
  habitId: string | undefined;
}

export function useDeleteHabit(habitId: string | undefined) {
  const queryClient = useQueryClient();

  return useMutation<null, null, IHabitId>(
    ["habit-delete", habitId],
    async ({ habitId }) => {
      const response = await api.delete(`habit/${habitId}`, {});

      if (response.status !== 200) {
        throw response.data;
      }
      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries("habits");
      },
    }
  );
}
